// Generated by https://pagedraw.io/pages/12008
import React from 'react';
import './spacerfive.css';


export default class Spacerfive extends React.Component {
  render() {
    return (
      <div className="spacerfive-spacerfive-9" /> 
    );
  }
};



// WEBPACK FOOTER //
// ./src/pagedraw/spacerfive.js